<template>
    <div class="upload_files">
        <el-tree
            :data="files"
            node-key="url"
            draggable
            empty-text=""
            :allow-drop="handleAllowDrop" 
            @node-drop="handleNodeDrop">
            <div class="file" slot-scope="scope">
                <el-button type="danger" size="small" icon="el-icon-delete" circle @click="deleteFiles(scope.data.url)"></el-button>
                <div class="icon" :class="getFileTypeClass(scope.data.type)" @click="downloadFile(scope.data)" :title="`点击下载${label}`"></div>
                <el-input type="text" size="small" :value="scope.data.name" @input="fileNameInput($event, scope.data.url)" :placeholder="`文件名称(不带扩展名，最多${inputMaxlength}个字符)`" :maxlength="inputMaxlength"></el-input>
                <span class="file_size" v-if="scope.data.loading"><i class="el-icon-loading"></i>正在上传</span>
                <span class="file_size" v-else-if="scope.data.size">{{formatFileSize(scope.data.size)}}</span>
            </div>
        </el-tree>
        <el-button type="primary" size="small" :title="`点击上传${label}`" v-show="files.length < fileMax" @click="uploadFile()">
            <span><i class="el-icon-plus"></i> 上传{{label}}</span>
        </el-button>
    </div>
</template>

<script>
import {
    formatFileSize
} from '@/common/tools';
import file from '@/common/file';
export default {
    name: 'Files',
    props: {
        label: {
            type: String,
            default: '文件'
        },
        fileType: {
            type: Array,
            default: ()=>['docx', 'doc', 'xlsx', 'xls', 'pptx', 'ppt', 'pdf']
        },
        fileSize: {
            type: Number,
            default: 1*1024*1024
        },
        fileMax: {
            type: Number,
            default: 1
        },
        value: Array,
        inputMaxlength: {
            type: Number,
            default: 50
        },
        uploaderOptions: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            files: []
        }
    },
    computed: {
        accept(){
            return this.fileType.map(type=>('.' + type)).join(',');
        },
    },
    watch: {
        value:{
            immediate: true,
            handler(newValue){
                if(newValue){
                    this.files = this.value.map(item=>({...item}));
                }else{
                    this.files = [];
                }
            }
        }
    },
    methods: {
        formatFileSize,
        handleAllowDrop(_, __, type){
            if(type == 'inner') return false;
            return true;
        },
        handleNodeDrop(draggingNode, dropNode){
            let arr = [...this.files];
            let dragData = draggingNode.data,
                dropData = dropNode.data;
            let dragItem = arr.splice(dragData.index, 1)[0];
            arr.splice(dropData.index, 0, dragItem);
            this.files = arr;
            this.change();
        },
        getFileTypeClass(type){
            if(['docx', 'doc'].includes(type)){
                return 'word';
            }else if(['xlsx', 'xls'].includes(type)){
                return 'excel';
            }else if(['pptx', 'ppt'].includes(type)){
                return 'ppt';
            }else if(['pdf'].includes(type)){
                return 'pdf';
            }else if(type){
                return type;
            }
            return '';
        },
        change(){
            let files = this.files.map(item=>({...item}));
            this.$emit('input', files);
            this.$emit('change', files);
        },
        fileNameInput(value, url){
            let index = this.files.findIndex(item=>item.url === url);
            if(!/^[^\/:*?"'`<>\|\\]+$/.test(value)){
                this.$message.warning("文件名称不能包含特殊字符");
            }
            value = value.replace(/[\/:*?"'`<>\|\\]/g, '');
            this.$set(this.files[index], 'name', value);
            this.change();
        },
        uploadFile(){
            file.cloose({
                accept: this.accept
            }).then(fileData=>{
                let name = fileData.name;
                let fileType = name.substr(name.lastIndexOf('.') + 1).toLowerCase();
                if(!this.fileType.includes(fileType)){
                    this.$message.error('不支持此文件类型');
                    return;
                }
                if (fileData.size > this.fileSize) {
                    this.$message.error(`文件大小不能超过 ${formatFileSize(this.fileSize)}，请压缩后上传`);
                    return;
                }
                let url = URL.createObjectURL(fileData);
                this.files.push({
                    url,
                    loading: true,
                    name: (name.substr(0, name.lastIndexOf('.')) || name).replace(/[\/:*?"'`<>\|\\]/g, '').substr(0, this.inputMaxlength),
                    size: fileData.size,
                    type: fileType
                })
                this.change();
                file.ossUpload({
                    file: fileData,
                    type: fileType,
                    uploadOptions: this.uploaderOptions
                }).then(data=> {
                    let index = this.files.findIndex(item=>item.url === url);
                    if(index >= 0){
                        let old = this.files[index];
                         this.$set(this.files, index, {
                            ...old,
                            url: data.url,
                            loading: false
                        });
                        this.change();
                    }
                }).catch(()=>{
                    let index = this.files.findIndex(item=>item.url === url);
                    if(index >= 0){
                        this.files.splice(index, 1);
                        this.change();
                    }
                    this.$message.error('文件上传失败，请重试！');
                });
            })
        },
        deleteFiles(url){
            let index = this.files.findIndex(item=>item.url === url);
            this.files.splice(index, 1);
            this.change();
        },
        downloadFile(data){
            if(data && !data.loading && data.url){
                file.download(data.url, data.name + (data.type ? `.${data.type}` : ''));
            }
        },
    }
}
</script>

<style scoped>
.upload_files{
    max-width: 700px;
}
.upload_files .file{
    display: flex;
    align-items: center;
}
.upload_files .file .icon{
    width: 38px;
    height: 38px;
    margin: 0 5px;
    background: no-repeat center / 100%;
}
.upload_files .pdf{
    background-image: url('~@/assets/icon/file_pdf.png') !important;
}
.upload_files .excel{
    background-image: url('~@/assets/icon/file_excel.png') !important;
}
.upload_files .ppt{
    background-image: url('~@/assets/icon/file_ppt.png') !important;
}
.upload_files .word{
    background-image: url('~@/assets/icon/file_word.png') !important;
}
.upload_files .file .el-input{
    width: 400px;
}
.upload_files .file .file_size{
    margin-left: 5px;
}
.upload_files::v-deep .el-tree .el-tree-node{
    margin-bottom: 10px;
}
</style>